var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralPrinciplesAnimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2165_2642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0463 0.0776672H6.16771C5.12332 0.0789183 4.12207 0.494354 3.38357 1.23285C2.64508 1.97134 2.22964 2.97259 2.22839 4.01698V15.8349C2.22839 16.6707 2.56042 17.4723 3.15143 18.0633C3.74244 18.6543 4.54403 18.9864 5.37985 18.9864H14.0463C15.0907 18.9851 16.092 18.5697 16.8305 17.8312C17.569 17.0927 17.9844 16.0914 17.9857 15.0471V4.01698C17.9844 2.97259 17.569 1.97134 16.8305 1.23285C16.092 0.494354 15.0907 0.0789183 14.0463 0.0776672V0.0776672ZM16.4099 4.01698V12.6835H6.95557V1.65339H14.0463C14.6732 1.65339 15.2744 1.90241 15.7176 2.34567C16.1609 2.78893 16.4099 3.39012 16.4099 4.01698ZM5.37985 1.78891V12.6835C4.82647 12.683 4.28283 12.829 3.80412 13.1066V4.01698C3.80419 3.52826 3.95575 3.05158 4.23794 2.65256C4.52013 2.25354 4.91908 1.95181 5.37985 1.78891V1.78891ZM14.0463 17.4106H5.37985C4.96194 17.4106 4.56114 17.2446 4.26564 16.9491C3.97013 16.6536 3.80412 16.2528 3.80412 15.8349C3.80412 15.417 3.97013 15.0162 4.26564 14.7207C4.56114 14.4252 4.96194 14.2592 5.37985 14.2592H16.4099V15.0471C16.4099 15.6739 16.1609 16.2751 15.7176 16.7184C15.2744 17.1616 14.6732 17.4106 14.0463 17.4106Z",
    fill: "#201F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2165_2642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9087,
    height: 18.9087,
    fill: "white",
    transform: "translate(0.652588 0.0776672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralPrinciplesAnimal);
export default __webpack_public_path__ + "static/media/General-principles-animal.68449eec9edf69d2408350fc1412439a.svg";
export { ForwardRef as ReactComponent };